<template>
    <div>
        <v-main class="waves"> </v-main>
        <v-container fluid>
            <header>
                <v-row no-gutters align="center" justify="center">
                    <h1 class="text--white80">Logout</h1>
                </v-row>
                <v-row no-gutters align="center" justify="center">
                    <p class="text--white80">You have successfully logged out of the application.</p>
                </v-row>
                <v-row no-gutters align="center" justify="center">
                    <v-btn class="btn-return"
                           @click="returnToLogin">
                        Return to log in
                    </v-btn>
                </v-row>
            </header>
        </v-container>
    </div>
</template>
<script lang="ts">
    import { defineComponent } from "vue";
    import { alarm } from "@/store";

    export default defineComponent({
        name: "Logout",
        setup() {
            alarm.clearAlarmData();

            const returnToLogin = () => {
                window.location.href = "/Identity/Account/Login";
            };

            return {
                returnToLogin
            };
        }
    });
</script>